import { useEffect, useState } from 'react';

/**
 * Sequential crossfade helper. When `value` changes it reports `hidden: true` for `outMs` (fade the
 * current content out), then swaps `displayed` to the new value and flips `hidden: false` (fade it
 * back in). Lets a single element crossfade its content with plain CSS -- no motion library -- while
 * staying interruptible: a fresh change mid-fade restarts the out phase.
 */
export const useCrossfadeValue = <T>(value: T, outMs: number): { displayed: T; hidden: boolean } => {
	const [displayed, setDisplayed] = useState(value);
	const [hidden, setHidden] = useState(false);

	useEffect(() => {
		if (value === displayed) return;
		setHidden(true);
		const id = setTimeout(() => {
			setDisplayed(value);
			setHidden(false);
		}, outMs);
		return () => clearTimeout(id);
	}, [value, displayed, outMs]);

	return { displayed, hidden };
};
